module.exports = __webpack_public_path__ + "img/3_134.7a0d45e0.png";